export default __webpack_public_path__ + "static/card-5-4f40007edab5cad7ec7b3484899394bd.svg";